import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Brain } from 'lucide-react';

const sections = [
  'Quantitative Aptitude',
  'Logical Reasoning',
  'Verbal Ability',
  'Data Interpretation',
  'Abstract Reasoning'
];

export default function AptitudeCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/assessment/aptitude/verify')}
      className="aptitude-card group relative w-full text-left overflow-hidden rounded-3xl p-6 md:p-7 transition-all duration-300"
    >
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-amber-500/10 to-orange-600/10 pointer-events-none" />

      <div className="relative z-10 flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center shadow-lg shadow-amber-500/30">
            <Brain className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-sora">MindEdge Aptitude Test</h3>
            <p className="text-sm text-slate-600">5 Sections · 50 Questions · ~45 min</p>
          </div>
        </div>

        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-amber-100/85 text-amber-800 border border-amber-200">
          Popular
        </span>
      </div>

      <p className="relative z-10 mt-4 text-sm leading-6 text-slate-700">
        Master quantitative reasoning, logical thinking, verbal ability, data interpretation, and abstract pattern recognition aligned to industry-standard hiring assessment patterns.
      </p>

      <div className="relative z-10 mt-5 flex flex-wrap gap-2">
        {sections.map((section) => (
          <span
            key={section}
            className="text-[11px] md:text-xs px-3 py-1 rounded-full border border-amber-200/80 bg-white/75 text-slate-700 backdrop-blur-sm"
          >
            {section}
          </span>
        ))}
      </div>

      <div className="relative z-10 mt-5">
        <div className="apt-cta-shimmer w-full rounded-xl bg-gradient-to-r from-amber-500 to-orange-600 text-white font-semibold px-4 py-3 flex items-center justify-center gap-2">
          Start Assessment
          <ArrowRight className="h-4 w-4" />
        </div>
      </div>
    </button>
  );
}
